import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dashlane = defineConnector({
  identifier: "dashlane",
  name: "Dashlane",
  tagLine: "Password management for teams",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.dashlane\\.com/public/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the Dashlane Admin Console, go to **Integrations > Developer Access**, select **Create API key**, enter a name, and click **Generate key**.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          placeholder: "DLP_…",
          helperText:
            "Paste the token starting with DLP_, without the leading “Bearer”.",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.dashlane.com/public/teams/Status",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    }),
  },
});
